import { useQuery } from "@tanstack/react-query";
import { Space } from "antd";
import { Link } from "react-router-dom";
import { fetchEmailTemplateLayouts } from "@/lib/api/resources/emailTemplateLayouts";
import { emailTemplateLayoutColumns } from "./lib/constants/emailTemplateLayoutColumns";
import { Table } from "@/components/v2";
import { Button } from "@rumbledirect/ui";
import { PlusOutlined } from "@ant-design/icons";

export const EmailTemplateLayoutsList = () => {
  const emailTemplateLayoutsQuery = useQuery({
    queryKey: ["emailTemplateLayouts"],
    queryFn: fetchEmailTemplateLayouts,
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/email-templates/layouts/create">
          <Button icon={<PlusOutlined />}>Nieuwe email template layout</Button>
        </Link>
      </Space>
      <Table
        columns={emailTemplateLayoutColumns}
        dataSource={emailTemplateLayoutsQuery?.data}
        loading={emailTemplateLayoutsQuery.isLoading}
        pagination={false}
      />
    </div>
  );
};
